import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";

import ScrollableCard from "../../../SharedComponents/ScrollableCard";
import JobLevel from "./Tabs/JobLevel";
import JobGroup from "./Tabs/JobGroup";
import Department from "./Tabs/Department";

export default function Organization() {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState("jobLevel");

  return (
    <div>
      <Row
        className={"tab-container-single-line text-20 text-color-gray-light fw-semibold"}
        style={{ height: "40px", margin: "0 12px 0px 12px" }}
      >
        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100 ${currentTab === "jobLevel" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => setCurrentTab("jobLevel")}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              {t("jobLevel")}
            </Col>
          </Row>
        </Col>

        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100 ${currentTab === "jobGroup" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => setCurrentTab("jobGroup")}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              {t("jobGroup")}
            </Col>
          </Row>
        </Col>

        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100 ${currentTab === "department" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => setCurrentTab("department")}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              {t("department")}
            </Col>
          </Row>
        </Col>
      </Row>

      <ScrollableCard>
        <Row className={"mx-0"}>
          <Col>
            {currentTab === "jobLevel" && <JobLevel />}
            {currentTab === "jobGroup" && <JobGroup />}
            {currentTab === "department" && <Department />}
          </Col>
        </Row>
      </ScrollableCard>
    </div>
  );
}
